<div class="login d-flex">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">

        <div class="login-header text-center">
          <img src="assets/images/consumable-logo.png" alt="consumable logo" class="logo" width="270"/>
          <p>Welcome to Consumable network</p>
        </div>

        <div class="login-content">
          <mat-card class="p-5">
            <mat-card-header class="mb-3">
              <mat-card-title>
                <h4>Sign in</h4>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div>
                <form #f="ngForm" class="d-flex flex-column">
                  <mat-form-field floatLabel="always" class="mb-2">
                    <input #email matInput
                           placeholder="Email"
                           name="email" value=""
                           required
                           email
                           [(ngModel)]="user.email"
                           (keyup.enter)="f.valid &&  login()">
                  </mat-form-field>
                  <mat-form-field  floatLabel="always">
                    <input type="password"
                           matInput
                           name="password"
                           placeholder="Password"
                           value=""
                           required
                           [(ngModel)]="user.password" (keyup.enter)=" f.valid && login()">
                    <mat-hint align="end">Forgot password? <a [routerLink]="'/forgot-password'">Click here</a></mat-hint>
                  </mat-form-field>
                </form>
              </div>
            </mat-card-content>
          </mat-card>

          <div class="box-controls text-center">
            <button type="button" mat-raised-button color="primary" class="iconed large" (click)="login()" [disabled]="!f.valid">
              <i class="fas fa-sign-in"></i>
              <span>Sign in</span>
            </button>
          </div>

          <small class="d-block text-center mt-4" [hidden]="!registerLinkVisible">
            Not a member yet? <a [routerLink]="'/register'">Register</a>
          </small>

<!--          <small class="d-block text-center mt-4" [hidden]="!termsAndConditions">-->
<!--            By using this dashboard you are agreeing with <a href="#"> terms and conditions</a>-->
<!--          </small>-->

        </div>

      </div>
    </div>
  </div>
</div>
